import { get, post } from "../helpers/api_helper"

export const getCamps = () => get("camp/list")
export const createCamp = data => post("camp/create", data)
export const updateCamp = (id, data) => post(`camp/edit/${id}`, data)

export const getCampRooms = (campId, all = false) =>
  get(`camp/${campId}/rooms${all ? "?all=1" : ""}`)
export const createRoom = data => post("camp/room/create", data)
export const updateRoom = (id, data) => post(`camp/room/edit/${id}`, data)
export const releaseRoom = (id, data) => post(`camp/room/release/${id}`, data)
export const getRoomPriceHistory = id => get(`camp/room/${id}/price-history`)
export const getMoveTargets = excludeRoomId => get(`camp/move-targets${excludeRoomId ? `?exclude_room_id=${excludeRoomId}` : ""}`)
export const getRoomOccupants = id => get(`camp/room/${id}/occupants`)

export const createBed = data => post("camp/bed/create", data)
export const updateBed = (id, data) => post(`camp/bed/edit/${id}`, data)
export const removeBed = id => post(`camp/bed/remove/${id}`, {})
// Room allotment — assign/vacate an employee to a bed; search employees to allot
export const allotBed = (bedId, data) => post(`camp/bed/allot/${bedId}`, data)
export const allotShared = (roomId, data) => post(`camp/room/${roomId}/allot-shared`, data)
export const vacateEmployee = (empId, data) => post(`camp/employee/${empId}/vacate`, data)
export const searchAllotEmployees = q => get(`camp/search-employees?q=${encodeURIComponent(q)}`)
export const getEmployeeCampHistory = empId => get(`camp/employee-history/${empId}`)

export const getCampDashboard = () => get("camp/dashboard")
export const getCampCostAnalysis = year => get(`camp/report/cost-analysis?year=${year}`)
export const getCampRentRegister = year => get(`camp/report/rent-register?year=${year}`)
export const getCampRentTransactions = year => get(`camp/report/rent-transactions?year=${year}`)
export const getCampGroups = () => get("camp/groups")
export const findCampOccupant = q => get(`camp/find-occupant?q=${encodeURIComponent(q)}`)
export const getOccupancyReport = (params = "") => get(`camp/occupancy-report?${params}`)
